import { useEffect, useState } from "react";
import { Field, Label } from "@headlessui/react";
import Password from "../../components/input/Password";
import RequiredField from "../../components/RequiredField";
import { RulesModel } from "../account/accountApiSlice";

interface FormProps {
	rules: RulesModel;
	isResettingForStudent: boolean;
	updatePassword: (password: string) => void;
	updateConfirmPassword: (confirmPass: string) => void;
	disableConfirm: (disable: boolean) => void;
}

export default function ResetPasswordForm(props: FormProps) {
	const minLength = props.isResettingForStudent
		? props.rules.writerPasswordMinLength
		: props.rules.nonWriterPasswordMinLength;
	const maxLength = props.rules.passwordMaxLength ?? 72;

	const [password, setPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");

	useEffect(() => {
		props.updatePassword(password);
	}, [password]);

	useEffect(() => {
		props.updateConfirmPassword(confirmPassword);
	}, [confirmPassword]);

	useEffect(() => {
		if (!password || !confirmPassword) {
			props.disableConfirm(true);
		} else if (password !== confirmPassword) {
			props.disableConfirm(true);
		} else if (password.length < minLength || password.length > maxLength) {
			props.disableConfirm(true);
		} else {
			props.disableConfirm(false);
		}
	}, [password, confirmPassword]);

	return (
		<div>
			<p className="text-sm leading-6 mt-2">
				{props.isResettingForStudent ? "Student passwords" : "Password"} must be at least{" "}
				{minLength} characters long and are case sensitive.
			</p>
			<Field className="mt-2">
				<div className="flex justify-between items-end">
					<Label htmlFor="password" className="font-semibold text-sm">
						Password
						<RequiredField />
					</Label>
					<p className="text-xs leading-6">
						<RequiredField className="!text-base" /> - Denotes a required field
					</p>
				</div>
				<Password
					id="passwordInput"
					name="password"
					className="mt-1 block w-full rounded-lg border-0 text-gray-900 text-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary-600"
					required={true}
					minLength={minLength}
					maxLength={maxLength}
					value={password}
					autoComplete="new-password"
					onChange={(e) => setPassword(e.target.value)}
				/>
			</Field>

			<Field className="mt-2">
				<Label htmlFor="confirmPassword" className="font-semibold text-sm">
					Confirm Password
					<RequiredField />
				</Label>
				<Password
					id="confirmPasswordInput"
					name="confirmPassword"
					placeholder="confirm password"
					className="mt-1 block w-full rounded-lg border-0 text-gray-900 text-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary-600"
					required={true}
					minLength={minLength}
					maxLength={maxLength}
					value={confirmPassword}
					autoComplete="confirm-pass"
					onChange={(e) => setConfirmPassword(e.target.value)}
				/>
			</Field>
		</div>
	);
}
